/*
 * @Description:支付
 * @Author: 山淑兰
 * @Date: 2020-01-05 23:27:34
 * @LastEditTime: 2020-04-28 19:54:34
 * @LastEditors: 山淑兰
 */
import { Post, Pick, Get } from "@/api/utils";
import { InitPayConfig, Create_PayOrder, IQueryOrder } from "./index.dto";

// const { API_HOST } = G_CONFIG;
const API_HOST = "";

export const PayPath = {
  Init_PayConfig: API_HOST + "/api/MeetingSign/InitPayConfig", //会议支付接口
  Create_PayOrder: API_HOST + "/api/MeetingSign/CreatePayOrder", //统一下单支付接口
  QueryOrder: API_HOST + "/api/Wx/QueryOrder", //查询订单是否支付状态
};

export default {
  /**
   * @title 获取token配置
   * @date 2020-01-05
   */
  InitPayConfig(body: InitPayConfig) {
    const params = Pick(body, InitPayConfig);
    return Post({
      url: PayPath.Init_PayConfig,
      params,
    });
  },
  /**
   * @title 统一下单支付接口
   * @date 2020-01-05
   */
  CreatePayOrder(body: Create_PayOrder) {
    const params = Pick(body, Create_PayOrder);
    return Post({
      url: PayPath.Create_PayOrder,
      params,
    });
  },
  /**
   * @title 获取token配置
   * @date 2020-01-05
   */
  QueryOrder(body: IQueryOrder) {
    const params = Pick(body, IQueryOrder);
    return Get({
      url: PayPath.QueryOrder,
      params,
    });
  },
};
